document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ee-gallery').forEach(function (gallery) {
    var tabs = gallery.querySelectorAll('.ee-gallery__tab');
    var items = gallery.querySelectorAll('.ee-gallery__item');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var category = this.getAttribute('data-category');

        tabs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');

        items.forEach(function (item) {
          if (category === 'all' || item.getAttribute('data-category') === category) {
            item.setAttribute('data-hidden', 'false');
            item.style.display = '';
          } else {
            item.setAttribute('data-hidden', 'true');
            item.style.display = 'none';
          }
        });
      });
    });
  });
});
